module.exports = __webpack_public_path__ + "static/img/3917_jdbbi4ow.0dee751.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3917_jdbbi4ow.png
// module id = noU5
// module chunks = 0